import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import { useMousePosition } from "../../hooks/useMousePosition";

const HeroSection = () => {
  const leftCoinRef = useRef(null);
  const rightCoinRef = useRef(null);
  const centerChipRef = useRef(null);
  const mouse = useMousePosition();

  useEffect(() => {
    gsap.to(leftCoinRef.current, {
      y: -20,
      repeat: -1,
      yoyo: true,
      duration: 1.5,
      ease: "power1.inOut",
    });

    gsap.to(rightCoinRef.current, {
      y: 20,
      repeat: -1,
      yoyo: true,
      duration: 1.8,
      ease: "power1.inOut",
    });

    gsap.to(centerChipRef.current, {
      rotate: 360,
      duration: 5,
      repeat: -1,
      ease: "linear",
    });
  }, []);

  return (
    <div className="relative w-full h-screen flex flex-col items-center justify-end pb-32 md:pb-20 text-white overflow-hidden">
      <div
        className="absolute inset-0 opacity-80"
        style={{
          background: `radial-gradient(circle at 0% 50%, rgba(0, 102, 255, 0.6), transparent 25%),
          radial-gradient(circle at 100% 50%, rgba(0, 102, 255, 0.6), transparent 25%),
          rgba(0, 0, 0, 0.5)`,
        }}
      ></div>

      <motion.img
        ref={leftCoinRef}
        src="/assets/Token.png"
        alt="Left Coin"
        className="absolute left-20 bottom-36 md:left-1/5 w-20 md:bottom-1/2 blur-sm"
        style={{
          transform: `translate(${mouse.x * 0.02}px, ${mouse.y * 0.02}px)`,
        }}
      />
      <motion.img
        ref={rightCoinRef}
        src="/assets/Token.png"
        alt="Right Coin"
        className="absolute right-10 md:right-1/5 top-1/5 blur-[2px]"
        style={{
          transform: `translate(${mouse.x * -0.02}px, ${mouse.y * -0.02}px)`,
        }}
      />

      <div className="relative flex flex-col items-center justify-center">
        <motion.img
          ref={centerChipRef}
          src="/assets/TokenChip.png"
          alt="Atheriam $ATH token"
          className="absolute bottom-[4rem] md:bottom-[3rem] z-0"
        />
        <img
          src="/assets/Mask.png"
          alt=""
          className="absolute bottom-[2rem] md:bottom-[2rem] w-1/2"
          aria-hidden="true"
        />

        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="relative z-20 mb-2 text-sm md:text-xl font-orbitron tracking-[0.35em] uppercase text-white/80"
        >
          Atheriam
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1, y: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative text-4xl md:text-9xl font-orbitron font-bold uppercase z-20"
        >
          TOKENOMICS
        </motion.h1>
      </div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 1 }}
        transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
        className="text-sm md:text-3xl font-gilroy text-gray-300 m-4 text-center max-w-4xl"
      >
        The <span className="font-bold">$ATH</span> token is the backbone of the
        Atheriam gaming ecosystem - powering transactions, rewards, and
        governance.
      </motion.p>
    </div>
  );
};

export default HeroSection;
